import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

const panelRoute = () => ({
  path: ":panelId",
  component: null,
  childRoutes: [],
});

export default store => ({
  path: `${TRANSCRIPT_ROUTES.TEMPLATE}/:templateId`,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-template-details" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [panelRoute()],
});
